<template>
  <proa-modal
    :modal="modal"
    :title="$t('common.modals.alertChangeOrganizationModal.title')"
    @close="onClose"
  >
    <div class="mb-4">{{ $t('common.modals.alertChangeOrganizationModal.message') }}</div>
    <div class="font-weight-w6 text-secondary mb-4">{{ $t('common.modals.alertChangeOrganizationModal.currentOrganization') }}</div>
    <div class="d-flex flex-md-row flex-column align-items-center">
      <div class="mt-2 mt-md-0 ml-md-4 d-flex flex-column justify-content-center align-items-center align-items-md-start">
        <div v-if="this.currentOrganization" class="mb-1 font-weight-w6">{{ this.currentOrganization.name }}</div>
      </div>
    </div>
    <br/>
    <template slot="footer">
      <proa-button
        @click.native="onClickCanceledOrganizationChange"
        class="default-button-width mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        @click.native="onClickConfirmedOrganizationChange"
        variant="secondary"
        class="default-button-width"
      >
        {{ $t('common.ok') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
import {  mapGetters , mapActions } from 'vuex'


export default {
  name: 'AlertChangeOrganizationModal',
  computed: {
    ...mapGetters({
      currentOrganization: 'auth/currentOrganization'
    })
  },
  methods: {
    ...mapActions({
      apiPutAuth: 'auth/update',
    }),
    onClose: function() {
      this.$emit('close')
    },

    async onClickConfirmedOrganizationChange(){
      const currentLocation = location.href
      await this.apiPutAuth({
        defaultOrganizationId: this.requiredOrganizationId
      })
      window.location = currentLocation
    },
    onClickCanceledOrganizationChange(){
      this.$emit('close')
      window.close()
    }
  },
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    requiredOrganizationId: {
      type:  [String, Number],
      default: () => 0
    }
  }
}
</script>
